{
  "name": "Harry Partch: 43 tone Just Intonation scale",
  "description": "The classic 43-tone 11-Limit Rational Intonation scale by Harry Partch, consisting of 43 divisions per octave derived symmetrically from both harmonic and subharmonic partial rows (otonalities and utonalities) up to a prime limit of 11. The ratio notation follows Partch's original tuning, but this version is transposed so 1/1 = A (441 Hz). The open strings are the ratios 32/27 (C), 16/9 (G), 4/3 (D), 1/1 (A), and 3/2 (E).",
  "scale": [
    "81/80",
    "33/32",
    "21/20",
    "16/15",
    "12/11",
    "11/10",
    "10/9",
    "9/8",
    "8/7",
    "7/6",
    "32/27",
    "6/5",
    "11/9",
    "5/4",
    "14/11",
    "9/7",
    "21/16",
    "4/3",
    "27/20",
    "11/8",
    "7/5",
    "10/7",
    "16/11",
    "40/27",
    "3/2",
    "32/21",
    "14/9",
    "11/7",
    "8/5",
    "18/11",
    "5/3",
    "27/16",
    "12/7",
    "7/4",
    "16/9",
    "9/5",
    "20/11",
    "11/6",
    "15/8",
    "40/21",
    "64/33",
    "160/81",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "43-JI-11LPartchA",
  "built_in_group": "Marc Sabat NYKY Ensemble",
  "key_labels": "scala_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "A",
    "A",
    "A",
    "B",
    "B",
    "B",
    "B",
    "B",
    "*nB",
    "B",
    "C",
    "*nC",
    "C",
    "C",
    "C",
    "D",
    "C",
    "D",
    "*nD",
    "D",
    "D",
    "E",
    "D",
    "E",
    "E",
    "*nE",
    "E",
    "F",
    "E",
    "F",
    "F",
    "F",
    "F",
    "♯F",
    "G",
    "*nG",
    "G",
    "G",
    "G",
    "G",
    "G",
    "A",
    "A"
  ],
  "note_colors": [
    "#ffffff",
    "#dee2da",
    "#dfffd6",
    "#ece6df",
    "#dee2da",
    "#cee3e2",
    "#e2eecd",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#ffffff",
    "#dee2da",
    "#dfffd6",
    "#fffae5",
    "#bae5f7",
    "#e2caca",
    "#ffe5e5",
    "#ffffff",
    "#dee2da",
    "#dfffd6",
    "#ece6df",
    "#ecc9a2",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#e4fbe6",
    "#dee2da",
    "#cee3e2",
    "#fffae5",
    "#d0d0d7",
    "#e2caca",
    "#ffe5e5",
    "#ffffff",
    "#dee2da",
    "#e2eecd",
    "#dfffd6",
    "#fffae5",
    "#ecc9a2",
    "#cee3e2",
    "#fffae5"
  ],
  "equivSteps": 43,
  "fundamental": 220.5,
  "reference_degree": 0,
  "center_degree": 18,
  "rSteps": 7,
  "drSteps": 4,
  "hexSize": 38,
  "rotation": -16.102113751,
  "exquis_anchor_note": 18
}
